import apiClient, { unwrap } from './client'

export interface AntispamConfig {
  greylist_enabled: boolean
  greylist_delay_secs: number
  dnsbl_enabled: boolean
  dnsbl_zones: string[]
  min_receive_interval_secs: number
}

// 灰名单已从代码层默认禁用，保存时不再下发这两个字段（后端按默认值处理）。
export interface AntispamInput {
  dnsbl_enabled: boolean
  dnsbl_zones: string[]
  min_receive_interval_secs: number
}

export const antispamApi = {
  get() {
    return unwrap<AntispamConfig>(apiClient.get('/antispam'))
  },
  put(input: AntispamInput) {
    return unwrap<AntispamConfig>(apiClient.put('/antispam', input))
  },
}
